import React from 'react'
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useUser } from './context/UserContext';
import './summary/reservationSummary.css'

const ReservationSummary = () => {
    const { date } = useUser();
    const stringDate = date.dia?.toString();
    const formatDateToSpanish = (formatDate: string | undefined) => {
        if(formatDate){
            return format(formatDate, "EEEE dd 'de' MMMM',' yyyy", { locale: es });
        } else {
            return ""
        }
    };
    const formatDate = formatDateToSpanish(stringDate);
    return (

        <div className='data-summary-container'>
            <div className='data-summary-date'>
                <h3>Datos de la reserva</h3>
                <p>
                    <span>Especialidad:</span>
                    Oftalmología
                </p>
                <p>
                    <span>Médico:</span>
                    {date.medico}
                </p>
                <p>
                    <span>Día:</span>
                    {formatDate}
                </p>
                <p>
                    <span>Hora:</span>
                    {date.hora}
                </p>


            </div>
            {/* <img src="images/logo-web-ceoft.png" alt="" /> */}
        </div>

    )
}

export default ReservationSummary
